import { compareByRelevance } from '../../utils'
import { UiApiCrudClientBaseV1 } from '../crud-client-base'
import type {
  IGetListConfigurationRequest,
  IGetRelevantListRequest,
  IList,
  IListConfiguration,
  IListCreateRequest,
  IListDelRequest,
  IListGetManyRequest,
  IListGetRequest,
  IListPutRequest,
} from '../../../types'

const BASE_PATH = '/v1/lists'

export class ListUiApiClientV1 extends UiApiCrudClientBaseV1<IList> {
  create = async (request: IListCreateRequest) =>
    this.restPost<IList>(BASE_PATH, request.list)

  get = async (request: IListGetRequest) =>
    this.restGet<IList>(`${BASE_PATH}/${request.uid}`)

  put = async (request: IListPutRequest) =>
    this.mergeAndPut(BASE_PATH, request.list)

  del = async (request: IListDelRequest) =>
    this.restDelete(`${BASE_PATH}/${request.uid}`)

  getMany = async (request: IListGetManyRequest) => {
    const { limit, page, name, resourceId, ...rest } = request as Record<
      string,
      unknown
    >
    const queryParams = this.buildQueryParams({
      limit,
      page,
      name,
      resourceId,
      ...rest,
    })
    const response = await this.restGet<{ items: IList[] }>(
      BASE_PATH,
      queryParams,
    )
    if (!response.items) throw new Error('Invalid response: missing "items"')
    return response.items
  }

  getItem(response: IList): IList {
    return response
  }

  public async getRelevant(request: IGetRelevantListRequest) {
    return this.restGet<IList>(`${BASE_PATH}/relevant`, {
      resourceId: request.resourceId,
    })
  }

  getListConfiguration = async (
    request: IGetListConfigurationRequest,
  ): Promise<IListConfiguration> => {
    const queryParams: Record<string, string> = {}
    if (request.uid) queryParams.uid = request.uid
    if (request.name) queryParams.name = request.name
    if (request.resourceId) queryParams.resourceId = request.resourceId
    return this.restGet<IListConfiguration>(
      `${BASE_PATH}/configuration`,
      queryParams,
    )
  }

  public getByName = async (name: string) =>
    (await this.getMany({ name, limit: 1000 })).sort(compareByRelevance)[0] ||
    null
}
